import { CheckCircle2, Plus } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface DisputeEmptyStateProps {
  hasDisputes: boolean;
  onCreateDispute: () => void;
}

export function DisputeEmptyState({ hasDisputes, onCreateDispute }: DisputeEmptyStateProps) {
  return (
    <Card className="glass-card border-gradient">
      <CardContent className="p-12 text-center">
        <div className="w-16 h-16 rounded-full bg-emerald-400/10 flex items-center justify-center mx-auto mb-4">
          <CheckCircle2 className="h-8 w-8 text-emerald-400" />
        </div>
        <h3 className="font-semibold text-lg mb-2">No Disputes Found</h3>
        <p className="text-muted-foreground mb-4">
          {hasDisputes
            ? "No disputes match your current filters."
            : "All your projects are running smoothly."}
        </p>
        {!hasDisputes && (
          <Button onClick={onCreateDispute} className="gradient-primary">
            <Plus className="h-4 w-4 mr-2" />
            Create New Dispute
          </Button>
        )}
      </CardContent>
    </Card>
  );
}

